<template>
  <!-- v-bind:style でCSS変数設定 -->
  <div class="cbm-btn-area mx-1" v-bind:style="setCompnentStyle">
    <span class="cbm-btn-area-left">
      <v-btn :disabled="disabled" class="cbm-btn-left px-1" color="#FFF" :width="leftButtonWidth" text dark @click="onExecButtonClick">{{ label }}</v-btn>
    </span>
    <span class="cbm-btn-area-right">
      <v-tooltip :top="top" :bottom="bottom">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-menu :top="top" :bottom="bottom" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" class="cbm-btn-right px-1" color="#FFF" dark text>▼</v-btn>
              </template>
              <v-list class="py-1" shape>
                <!-- サブメニューの中身は呼び出し側で任意設定可能 -->
                <slot></slot>
              </v-list>
            </v-menu>
          </div>
        </template>
        <span v-html="optionTooltipText"></span>
      </v-tooltip>
    </span>
  </div>
</template>
<script>
/**
 * @file DDv2用標準ボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
  <dd-custom-button-with-menu
    label="検索"
    :top="false"
    :bottom="true"
    @exec="onClickSearchButton"
  >
    <v-list-item class="cbm-btn-menu">
      <v-list-item-content>
        <v-checkbox v-model="andOutpuExcelFlg" label="同時にEXCEL出力も行う" />
      </v-list-item-content>
    </v-list-item>
  </dd-custom-button-with-menu>

 * @note
 * v-list-itemのstyle定義は呼び出し元で実施してください。
 * 以下定義例です
  .cbm-btn-menu {
    margin: 2px 4px;
    min-height: 24px !important;
  }
  .cbm-btn-menu > .v-list-item__content {
    padding: 0px 0px !important;
  }
 */
export default {
  name: 'DdCustomButtonWithMenu',

  // プロパティ定義
  props: {
    /**
     * 基本プロパティ
     */
    label: {
      type: String,
      default: ''
    },
    color: {
      /**
       * ※色はCSS定義されている形式で指定する事
       *   OK例：color="white", color="#FFF"等
       *   NG例：color="primary"
       */
      type: String,
      default: '#2F75B5'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 200
    },
    /**
     * 表示位置：デフォルトはtop
     * ※bottomにしたい場合は呼び出し元で[:top="false"]も指定する事
     */
    top: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    /**
     * メニュー展開用ボタンツールチップテキスト
     */
    optionTooltipText: {
      type: String,
      default: 'その他実行オプション'
    }
  },
  data: () => ({
    leftButtonWidth: 160,
    rightButtonWidth: 34
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    /*
     * CSS変数設定
     */
    setCompnentStyle () {
      return {
        '--button-width': this.width + 'px',
        '--left-button-width': this.width - 34 + 'px',
        '--background-color': this.color
      }
    }
  },
  watch: {
    width: function (n) {
      /* 主ボタン幅設定 */
      if (![undefined, null, ''].includes(n) && n > 50) {
        this.leftButtonWidth = n - this.rightButtonWidth - 10
      } else {
        this.width = 200
        this.leftButtonWidth = 160
      }
      console.log('setLeftButtonWith : ', this.leftButtonWidth)
    }
  },
  mounted: function () {
  },
  methods: {
    onExecButtonClick: function (e) {
      this.$emit('exec')
    }
  }
}
</script>
<style scoped>
i::before {
  color: darkslategray !important;
}
.cbm-btn-area {
  background-color:var(--background-color);
  border-radius:20px;
  width: var(--button-width);
  vertical-align:middle
}
.cbm-btn-area:hover {
    box-shadow: 0 1px 2px 0 rgba(26,115,232,0.451), 0 1px 3px 1px rgba(26,115,232,0.302);
    background-color: var(--background-color);
    outline: 1px solid transparent;
    border: none;
}
.cbm-btn-area-left {
  display: inline-block;
  width: var(--left-button-width);
}
.cbm-btn-area-right {
  border-left: 2px #FFF solid;
  float: right;
  width: 34px;
}
.cbm-btn-left {
    min-width: 80px !important;
    padding: 0px 0px 0px 10px !important;
}
.cbm-btn-left:hover {
  transform: scale(1.05);
}
.cbm-btn-right {
    min-width: 30px !important;
    padding: 0px 4px 0px 0px !important;
}
.cbm-btn-right:hover {
  transform: scale(1.1);
}
</style>
